/**
 * Router navigation for code that lives ABOVE the router.
 *
 * `useGlobalSocketEvents` runs in AppProviders — outside RouterProvider — so
 * it can't call useNavigate, yet a message-toast click must route (open the
 * WhatsApp inbox on a chat, etc.). ProtectedRoute registers the live navigate
 * function here on every authed render; callers get a real SPA navigation.
 * Before registration (login page, cold boot) the fallback is a full-page
 * assign — correct, just heavier, and only reachable from surfaces that
 * exist pre-auth (none of the current callers).
 */
import type { NavigateFunction } from "react-router-dom";

let nav: NavigateFunction | null = null;

export function registerGlobalNavigate(n: NavigateFunction) {
  nav = n;
}

export function globalNavigate(to: string) {
  if (nav) nav(to);
  else window.location.assign(to);
}
